
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
// import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryListProvider } from "../../../component/solution/QueryTableList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";
import { QueryTableList } from "../../../component/solution/QueryTableList/QueryTableList";
import { formatDateFull } from "../../../component/solution/utils/AppUtil";

export const ItemParts: React.FC = () => {

    return(
        <React.Fragment>
            {/* <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Stock Master"}
                        recordTitle={"Stock Master"}
                        tableName={"sa_item_parts"}
                        editTableName={"sa_customer"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "item_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_description",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_type",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "item_category",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            },
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                                fullColumnName: "created",
                                direction: "DESC",
                                cast: CastType.STRING
                            }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container> */}

            <Container fluid className="p-0">
              <QueryListProvider>
                <QueryTableList
                    listTitle={"Stock Master"}
                    recordTitle={"Stock Master"}
                    tableName={""}
                    editTableName={""}
                    hasIntegrationStatusLegend={false} 
                    errorCategoryName={''}
                    editHasCompoundKey={false}   
                    showFailedTransactionsTable={false}
                    query={{
                        appCode: null,
                        selectCode: null,
                        tableName: "sa_item_parts",
                        where: "",
                        orderBy: 'created ASC',
                        pageNum: 0,
                        pageSize: 100,
                        params: {},
                    }} 
                    orderColumns={[
                            { name: "item_code", type: "STRING", sortable: true, searchable: true },
                            { name: "item_description", type: "STRING", sortable: true, searchable: true },
                            { name: "item_type", type: "STRING", sortable: true, searchable: true },
                            { name: "item_category", type: "STRING", sortable: true, searchable: true },
                            { name: "fixably_id", type: "INTEGER", sortable: true, searchable: true },
                            { name: "fixably_updated", type: "BOOLEAN", sortable: true, searchable: true },
                            { name: "created", type: "TIMESTAMP", sortable: true, searchable: false },
                            { name: "updated", type: "TIMESTAMP", sortable: true, searchable: false }
                    ]}
                    renderRowData={(row) => {
                                            
                        const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                        const tdEllipsis: React.CSSProperties = {...tdStyle, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'};
                    
                        return (
                            <>
                                <td style={tdStyle} title={row.item_code}>{row.item_code}</td>
                                <td style={tdEllipsis} title={row.item_description}>{row.item_description}</td>
                                <td style={tdStyle} title={row.item_type}>{row.item_type}</td>
                                <td style={tdStyle} title={row.item_category}>{row.item_category}</td>
                                <td style={tdStyle} title={row.fixably_id}>{row.fixably_id}</td>
                                <td style={tdStyle} title={row.fixably_updated}>{row.fixably_updated}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.created))}>{formatDateFull(String(row.created))}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.updated))}>{formatDateFull(String(row.updated))}</td>
                            </>    
                        );
                    }}   
                    renderActions={(row) => {
                            return (
                                <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                    
                                </td>
                            );
                    }}                      
                />
            </QueryListProvider>
          </Container> 
       </React.Fragment>
    );
}